import {
  GET,POST
} from '../libs/axios'


export const getHomeNews = (params) => GET(`/public/config/news`, params, {})


/**
 * 获取公共配置
 */

export const getConfig = (params) => POST(`/public/common/config/get`, params, {})
export const updateConfig = (params) => POST(`/public/common/config/update`, params, {})


export const isLogin = (params) => POST(`/public/docking/isLogin`, params, {})

export const addContact = (params) => POST(`/public/impactx/addContact`, params, {})


export const searchAuthor = (params) => POST(`/public/valurev/searchAuthor`, params, {})

export const searchArticle = (params) => POST(`/public/valurev/searchArticle`, params, {})
export const getPerson = (params) => GET(`/public/valurev/getPerson`, params, {})
export const getPersonByAuthorName = (params) => GET(`/public/valurev/getPersonByAuthorName`, params, {})


export const getPersonInterests = (params) => GET(`/public/valurev/getPersonInterests`, params, {})

export const getPersonInterestList = (params) => GET(`/public/valurev/getPersonInterestList`, params, {})

export const getCoAuthor = (params) => GET(`/public/valurev/getCoAuthor`, params, {})
export const getCoOrg = (params) => GET(`/public/valurev/getCoOrg`, params, {})



export const getProjectList = (params) => GET(`/public/valurev/invitation/getProjectList`, params, {})
export const getProject = (params) => GET(`/public/valurev/invitation/getProject`, params, {})
export const addProject = (params) => GET(`/public/valurev/invitation/addProject`, params, {})
export const updateProject = (params) => GET(`/public/valurev/invitation/updateProject`, params, {})
export const deleteProject = (params) => GET(`/public/valurev/invitation/deleteProject`, params, {})


export const getInvitationList = (params) => GET(`/public/valurev/invitation/getInvitationList`, params, {})
export const addInvitation = (params) => GET(`/public/valurev/invitation/addInvitation`, params, {})
export const getInvitation = (params) => GET(`/public/valurev/invitation/getInvitation`, params, {})

export const getEmailInvitationReviewList = (params) => GET(`/public/valurev/invitation/getEmailInvitationReviewList`, params, {})
export const getPinReviewerList = (params) => GET(`/public/valurev/invitation/getPinReviewerList`, params, {})
export const getDraftReviewerList = (params) => GET(`/public/valurev/invitation/getDraftReviewerList`, params, {})
export const saveDraftReviewerList = (params) => POST(`/public/valurev/invitation/saveDraftReviewerList`, params, {})
export const savePinReviewer = (params) => GET(`/public/valurev/invitation/savePinReviewer`, params, {})
export const deletePinReviewer = (params) => GET(`/public/valurev/invitation/deletePinReviewer`, params, {})
export const getEmailInvitationReviewListByUserId = (params) => GET(`/public/valurev/invitation/getEmailInvitationReviewListByUserId`, params, {})
export const getEmailInvitationReviewJournalListByUserId = (params) => GET(`/public/valurev/invitation/getEmailInvitationReviewJournalListByUserId`, params, {})
export const getEmailInvitationReviewStateByUserId = (params) => GET(`/public/valurev/invitation/getEmailInvitationReviewStateByUserId`, params, {})


export const updateEmailInvitationReview = (params) => POST(`/public/valurev/invitation/updateEmailInvitationReview`, params, {})

export const getEditor = (params) => GET(`/public/valurev/invitation/getEditor`, params, {})

// 上传图例
export const uploadManuscript = (params) => POST(`/public/valurev/invitation/upload`, params, {headers:{
    "Content-Type":"multipart/form-data"
  }})
export const getParseProcess = (params) => GET(`/public/valurev/invitation/getParseProcess`, params, {})
export const parseManuscript = (params) => GET(`/public/valurev/invitation/parseManuscript`, params, {})
export const getInvitationManuscript = (params) => GET(`/public/valurev/invitation/getInvitationManuscript`, params, {})
export const searchReviewer = (params) => POST(`/public/valurev/invitation/searchReviewer`, params, {})
export const startInvitation = (params) => POST(`/public/valurev/invitation/startInvitation`, params, {})

export const deleteInvitation = (params) => GET(`/public/valurev/invitation/deleteInvitation`, params, {})


export const updateManuscript = (params) => GET(`/public/valurev/invitation/updateManuscript`, params, {})
export const getManuscriptKeywordList = (params) => GET(`/public/valurev/invitation/getManuscriptKeywordList`, params, {})
export const addManuscriptKeyword = (params) => GET(`/public/valurev/invitation/addManuscriptKeyword`, params, {})
export const deleteManuscriptKeyword = (params) => GET(`/public/valurev/invitation/deleteManuscriptKeyword`, params, {})

export const getManuscriptAuthorList = (params) => GET(`/public/valurev/invitation/getManuscriptAuthorList`, params, {})
export const addManuscriptAuthor = (params) => GET(`/public/valurev/invitation/addManuscriptAuthor`, params, {})
export const updateManuscriptAuthor = (params) => GET(`/public/valurev/invitation/updateManuscriptAuthor`, params, {})
export const deleteManuscriptAuthor = (params) => GET(`/public/valurev/invitation/deleteManuscriptAuthor`, params, {})

export const getYearCount = (params) => GET(`/public/valurev/invitation/getYearCount`, params, {})
export const getIfsCount = (params) => GET(`/public/valurev/invitation/getIfsCount`, params, {})
export const getArticleList = (params) => GET(`/public/valurev/invitation/getArticleList`, params, {})

export const translateByPmid = (params) => POST(`/public/article/translateByPmid`, params, {})

export const getAuthorUserState = (params) => GET(`/public/valurev/invitation/getAuthorUserState`, params, {})
export const getReviewRewardConditionList = (params) => GET(`/public/valurev/invitation/getReviewRewardConditionList`, params, {})
export const addReviewRewardCondition = (params) => GET(`/public/valurev/invitation/addReviewRewardCondition`, params, {})

export const getOrgList = (params) => GET(`/public/valurev/getOrgList`, params, {})

export const updatePerson = (params) => POST(`/public/valurev/updatePerson`, params, {})

export const addDomain = (params) => POST(`/public/valurev/addDomain`, params, {})
export const updateDomain = (params) => POST(`/public/valurev/updateDomain`, params, {})
export const deleteDomain = (params) => GET(`/public/valurev/deleteDomain`, params, {})

// export const getArticleList = (params) => GET(`/public/valurev/getArticleList`, params, {})
export const addArticle = (params) => POST(`/public/valurev/addArticle`, params, {})
export const updateArticle = (params) => POST(`/public/valurev/updateArticle`, params, {})
export const deleteArticle = (params) => GET(`/public/valurev/deleteArticle`, params, {})

export const getAuthorList = (params) => GET(`/public/valurev/getAuthorList`, params, {})
export const addAuthor = (params) => POST(`/public/valurev/addAuthor`, params, {})
export const updateAuthor = (params) => POST(`/public/valurev/updateAuthor`, params, {})
export const deleteAuthor = (params) => GET(`/public/valurev/deleteAuthor`, params, {})

export const searchOrg = (params) => GET(`/public/valurev/searchOrg`, params, {})

export const searchAllOrg = (params) => GET(`/public/valurev/searchAllOrg`, params, {})
export const searchAllAuthorByOrg = (params) => GET(`/public/valurev/searchAllAuthorByOrg`, params, {})



export const searchAUser = (params) => GET(`/public/valurev/searchAUser`, params, {})
export const searchAOrg = (params) => GET(`/public/valurev/searchAOrg`, params, {})

// export const searchNickName = (params) => GET(`/public/valurev/searchNickName`, params, {})
export const searchJournalName = (params) => GET(`/public/valurev/searchJournalName`, params, {})

export const extraArticleByDoi = (params) => GET(`/public/valurev/extraArticleByDoi`, params, {})
export const getYearCountList = (params) => GET(`/public/valurev/getYearCountList`, params, {})

export const getPersonArticleList = (params) => GET(`/public/valurev/getPersonArticleList`, params, {})

export const getPersonArticleJournalList = (params) => GET(`/public/valurev/getPersonArticleJournalList`, params, {})



export const translateText = (params) => POST(`/public/valurev/invitation/translateText`, params, {})
export const translateTextByGPT = (params) => POST(`/public/valurev/invitation/translateTextByGPT`, params, {})


export const getApcPublisherList = (params) => GET(`/public/valurev/getApcPublisherList`, params, {})
export const getApcPublisherJournalList = (params) => GET(`/public/valurev/getApcPublisherJournalList`, params, {})

export const getCoOrgList = (params) => GET(`/public/valurev/getCoOrgList`, params, {})
export const getCoLinkList = (params) => GET(`/public/valurev/getCoLinkList`, params, {})

export const getArticleListByKeyword = (params) => GET(`/public/valurev/invitation/getArticleListByKeyword`, params, {})

export const extraReviewerByText = (params) => GET(`/public/valurev/invitation/extraReviewerByText`, params, {})

